import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[rlTabIndex]'
})
export class TabIndexDirective implements OnInit {

  @Input("rlTabIndex") value? : number;

  @HostBinding("tabindex") tabIndex : number;

  ngOnInit(){
    this.tabIndex = this.value || 0;
  }
}
